export default {
      id: "menu__alarm-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__alarm",
      toString: function () {
        return this.url;
      }
    }